import { render } from "./SharedCv.vue?vue&type=template&id=50cb31ed"
import script from "./SharedCv.vue?vue&type=script&lang=js"
export * from "./SharedCv.vue?vue&type=script&lang=js"

import "./SharedCv.vue?vue&type=style&index=0&id=50cb31ed&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__